// Stroke icons for the merchant shell chrome — the design's ICON map (M:6594-6612)
// plus the few glyphs its top bar, popovers and sheets draw inline. Path data only
// (no brand, no colour): each icon strokes `currentColor`, so the caller's CSS
// decides light/dark. A named single-purpose shell file (CB-17).
const PATHS = {
  home: ['m3 10.5 9-7 9 7V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z', 'M9 21v-6h6v6'],
  calendar: ['M8 2v4', 'M16 2v4', 'M3 6h18v15H3z', 'M3 11h18'],
  layers: ['m12 2 9 5-9 5-9-5z', 'm3 12 9 5 9-5', 'm3 17 9 5 9-5'],
  store: ['M3 9l1.5-5h15L21 9', 'M3 9h18v11H3z', 'M9 20v-6h6v6'],
  tag: ['M4 4h8l8 8-8 8-8-8z', 'M8.5 8.5h.01'],
  megaphone: ['m3 11 15-6v12L3 13z', 'M7 12.5V17a2 2 0 0 0 4 0v-3'],
  chart: ['M3 21h18', 'M6 17V9', 'M12 17V5', 'M18 17v-8'],
  users: [
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2',
    'M9 3.2a4 4 0 1 1 0 7.6 4 4 0 0 1 0-7.6',
    'M22 21v-2a4 4 0 0 0-3-3.87',
  ],
  taka: ['M2 7h20v10H2z', 'M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4', 'M6 12h.01', 'M18 12h.01'],
  person: ['M12 3.5a4 4 0 1 1 0 8 4 4 0 0 1 0-8', 'M4 21a8 8 0 0 1 16 0'],
  inbox: ['M4 5h16v14H4z', 'm4 7 8 6 8-6'],
  qr: [
    'M4 4h6v6H4z',
    'M14 4h6v6h-6z',
    'M4 14h6v6H4z',
    'M14 14h2v2h-2z',
    'M18 18h2v2h-2z',
    'M14 18h2',
    'M18 14h2',
  ],
  more: ['M5 12h.01', 'M12 12h.01', 'M19 12h.01'],
  lock: ['M5 11h14v10H5z', 'M8 11V7a4 4 0 0 1 8 0v4'],
  shield: ['M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z'],
  search: ['M11 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14', 'm16.5 16.5 4 4'],
  bell: ['M18 16V10a6 6 0 0 0-12 0v6l-2 3h16z', 'M10 21h4'],
  help: [
    'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18',
    'M12 17h.01',
    'M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.3',
  ],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
  chevron: ['m6 9 6 6 6-6'],
  chevronLeft: ['m15 6-6 6 6 6'],
  close: ['m6 6 12 12', 'm18 6-12 12'],
  check: ['m5 13 4 4 10-10'],
  checkCircle: ['M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18', 'm8.5 12.5 2.5 2.5 4.5-5'],
  plus: ['M12 5v14', 'M5 12h14'],
  link: [
    'M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1',
    'M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1',
  ],
  filter: ['M4 6h16', 'M7 12h10', 'M10 18h4'],
  gear: [
    'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6',
    'M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1v.3a2 2 0 1 1-4 0v-.2a1.6 1.6 0 0 0-2.8-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.6 1.6 0 0 0 3.5 14H3a2 2 0 1 1 0-4h.2A1.6 1.6 0 0 0 4.3 7.2l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 10 3.5V3a2 2 0 1 1 4 0v.2a1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7h.4a2 2 0 1 1 0 4h-.2a1.6 1.6 0 0 0-1.4 1z',
  ],
  chat: [
    'M21 11.5a8.4 8.4 0 0 1-9 8.4 8.9 8.9 0 0 1-4-.9L3 21l1.9-4.5A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5Z',
  ],
  phone: [
    'M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.6a2 2 0 0 1-.5 2.1L8.1 9.6a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.6 2.6.7a2 2 0 0 1 1.7 2Z',
  ],
  external: ['M7 17 17 7', 'M8 7h9v9'],
  alert: ['M12 4 3 20h18z', 'M12 10v4', 'M12 17h.01'],
  clock: ['M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18', 'M12 8v4l3 2'],
  star: ['m12 3 2.7 5.6 6.3.9-4.5 4.3 1.1 6.2L12 17.1 6.4 20l1.1-6.2L3 9.5l6.3-.9z'],
  wallet: [
    'M3 7h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z',
    'M3 7V6a2 2 0 0 1 2-2h11',
    'M17 13h.01',
  ],
  sidebar: ['M4 4h16v16H4z', 'M9 4v16'],
} as const;

export type NavIconName = keyof typeof PATHS;

export function NavIcon({
  name,
  size = 18,
  strokeWidth = 1.8,
  className,
}: {
  name: NavIconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
